import axios from 'axios';
import { join } from 'path';

class VoucherService {
  constructor(http, endpoint) {
    this.http = http;
    this.endpoint = endpoint;
  }
  async validateVoucher(code) {
    return this.http.get(`${this.endpoint}/api/validate_voucher?voucher_code=${code}`)
      .then(r => r.data);
  }
  async applyVoucher(code, delivery_weekday, shipping_run, recipe_ids, portion_count) {
    return this.http.request({
      url: `${this.endpoint}/onboarding/apply_voucher`,
      method: 'put',
      data: `portion_count=${portion_count}&code=${code}&delivery_weekday=${delivery_weekday}&shipping_run_id=${shipping_run}&recipe_ids=${encodeURIComponent(recipe_ids.toString())}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
    })
      .then(r => r.data);
  }
}

export const voucherService = new VoucherService(axios, `https://www.mindfulchef.com`);